"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "2xl:container mx-auto pb-4" };
const _hoisted_2 = { class: "text-2xl print-text-sm pl-5 my-5 font-bold uppercase" };
const _hoisted_3 = { class: "filters justify-between lg:items-end print:hidden" };
const _hoisted_4 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_5 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_6 = { class: "flex flex-row gap-1 justify-center items-center print:hidden" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "uppercase font-bold border-b-1 border-gray pb-3" };
const _hoisted_9 = ["href"];
const _hoisted_10 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const vue_3 = require("vue");
const shop_1 = require("../../common/utils/shop");
const i18n_1 = require("../../common/i18n");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const Alert_vue_1 = __importDefault(require("../../components/Alert.vue"));
const vue_router_1 = require("vue-router");
const securityStore_1 = require("../../stores/security/securityStore");
const toastStore_1 = require("../../stores/toast/toastStore");
const carcassReturnStore_1 = require("../../stores/carcassReturn/carcassReturnStore");
const Form_1 = require("../../components/Form");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const AsyncSearchInputOption_1 = __importDefault(require("../../components/Form/AsyncSearchInput/AsyncSearchInputOption"));
const userStore_1 = require("../../stores/user/userStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CarcassReturnList',
    setup(__props) {
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const carcassStore = (0, carcassReturnStore_1.useCarcassReturnStore)();
        const uploadedFile = (0, vue_3.ref)(null);
        const router = (0, vue_router_1.useRouter)();
        const successfulSubmissionModalIsOpen = (0, vue_3.ref)(false);
        const selectedCarcass = (0, vue_3.ref)(null);
        const errorMessage = (0, vue_3.ref)("");
        const defaultFilterStartDate = (0, vue_3.computed)(() => {
            let halfYearBeforeToday = new Date();
            halfYearBeforeToday.setMonth(halfYearBeforeToday.getMonth() - 6);
            return (0, shop_1.formatDate)(halfYearBeforeToday);
        });
        const defaultFilterEndDate = (0, vue_3.computed)(() => {
            return (0, shop_1.formatDate)(new Date());
        });
        const filter = (0, vue_3.ref)({
            startDate: defaultFilterStartDate.value,
            endDate: defaultFilterEndDate.value,
            carcassId: null,
            userId: null
        });
        const currentUserPermission = (0, vue_3.computed)(() => {
            var _a;
            return !!((_a = securityStore.authenticatedUser) === null || _a === void 0 ? void 0 : _a.hasPermission(PermissionEnum_1.CarcassReturnPermissionEnum.CARCASS_RETURN_SHOW_ALL));
        });
        const customerAsyncSearchInput = (0, vue_3.ref)(null);
        const userStore = (0, userStore_1.useUserStore)();
        const customerSearchedValueChanged = (customerSearchedValue) => {
            userStore.reset();
            let payload = {
                page: 1,
                itemsPerPage: 5,
            };
            if (!isNaN(Number(customerSearchedValue))) {
                payload.id = customerSearchedValue;
            }
            else {
                payload["email"] = customerSearchedValue;
            }
            userStore
                .getUsers(router, payload);
        };
        const customerSelected = (value) => {
            userStore.reset();
            filter.value.userId = value.value;
        };
        const customerOptions = (0, vue_3.computed)(() => userStore.users.map((user) => new AsyncSearchInputOption_1.default(`${user.email}`, user.id)));
        const saveCarcassFile = async () => {
            errorMessage.value = "";
            if (selectedCarcass.value === null) {
                return;
            }
            const formData = new FormData();
            if (uploadedFile.value === null) {
                errorMessage.value = "File is not browsed!";
                return;
            }
            formData.append("file", uploadedFile.value);
            formData.append("carcassId", String(selectedCarcass.value.id));
            try {
                await carcassStore.saveCarcassFile(router, formData);
                if (selectedCarcass.value === null)
                    return;
                uploadedFile.value = null;
                await carcassStore.getCarcassFiles(router, filter.value);
                await carcassStore.sendCarcassFileUploadEmail(router, { carcassId: selectedCarcass.value.id });
                toastStore.addToast({
                    message: (0, i18n_1.trans)("email_sent_successfully", "Email is sent successfully!", "carcass_return_list"),
                    type: "success",
                    timer: 5,
                });
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
        };
        const deleteCarcassFile = async (carcassFileId) => {
            if (!confirm((0, i18n_1.trans)("delete_carcass_file_confirm", "Are you sure?", "carcass_return_list"))) {
                return;
            }
            errorMessage.value = "";
            try {
                await carcassStore.deleteCarcassFiles(router, carcassFileId);
                if (selectedCarcass.value === null)
                    return;
                carcassStore.reset();
                await carcassStore.getCarcassFiles(router, filter.value);
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
        };
        const listFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (0, i18n_1.trans)("id", "ID", "carcass_return_list"),
                value: "id",
            },
            {
                key: "email",
                label: (0, i18n_1.trans)("email", "email", "carcass_return_list"),
                value: "email",
                visible: currentUserPermission.value
            },
            {
                key: "createdDate",
                label: (0, i18n_1.trans)("site_name", "createdDate", "carcass_return_list"),
                value: "createdDate",
            },
            {
                key: "quantity",
                label: (0, i18n_1.trans)("quantity", "quantity", "carcass_return_list"),
                value: "quantity",
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const listFileFields = (0, vue_3.ref)([
            {
                key: "originalFileName",
                label: (0, i18n_1.trans)("originalFileName", "File name", "carcass_return_list"),
                value: "originalFileName",
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const printPage = () => {
            window.print();
        };
        const queryCarcassReturns = async () => {
            if (filter.value.startDate === "") {
                filter.value.startDate = defaultFilterStartDate.value;
            }
            if (filter.value.endDate === "") {
                filter.value.endDate = defaultFilterEndDate.value;
            }
            carcassStore.getCarcasses(router, filter.value)
                .catch((error) => { toastStore.addErrorToast(error.toString()); });
        };
        const openCarcassModel = (item) => {
            selectedCarcass.value = { ...item };
            filter.value.carcassId = selectedCarcass.value.id;
            carcassStore.getCarcassFiles(router, filter.value)
                .catch((error) => { toastStore.addErrorToast(error.toString()); });
            successfulSubmissionModalIsOpen.value = true;
        };
        (0, vue_3.onBeforeMount)(() => {
            carcassStore.reset();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('carcass_return_list', 'Carcass return List', 'carcass_return_list')), 1),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('start_date_placeholder', 'Start Date', 'carcass_return_list'),
                            label: (0, vue_2.unref)(i18n_1.trans)('start_date_label', 'Start Date', 'carcass_return_list'),
                            modelValue: filter.value.startDate,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filter.value.startDate) = $event)),
                            type: "date",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('end_date_placeholder', 'End Date', 'carcass_return_list'),
                            label: (0, vue_2.unref)(i18n_1.trans)('end_date_label', 'End Date', 'carcass_return_list'),
                            modelValue: filter.value.endDate,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((filter.value.endDate) = $event)),
                            type: "date",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('carcass_id_placeholder', 'e.g.: 25', 'carcass_return_list'),
                            label: (0, vue_2.unref)(i18n_1.trans)('carcass_id', 'Carcass ID', 'carcass_return_list'),
                            modelValue: filter.value.carcassId,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((filter.value.carcassId) = $event)),
                            class: "invoice-filter-input",
                            type: "text",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        ((0, vue_2.unref)(currentUserPermission))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(Form_1.AsyncSearchInput), {
                                key: 0,
                                ref_key: "customerAsyncSearchInput",
                                ref: customerAsyncSearchInput,
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('customer_placeholder', 'Customer', 'users'),
                                label: (0, vue_2.unref)(i18n_1.trans)('customer_label', 'Customer', 'users'),
                                border: "",
                                onSearchedValueChanged: customerSearchedValueChanged,
                                onSelected: customerSelected,
                                options: (0, vue_2.unref)(customerOptions),
                                modelValue: filter.value.userId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((filter.value.userId) = $event))
                            }, null, 8, ["placeholder", "label", "options", "modelValue"]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-warning h-[48px]",
                            onClick: _cache[4] || (_cache[4] = ($event) => (printPage()))
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("print", "Print", "customer_product_return_list")), 1),
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-primary h-[48px]",
                            onClick: queryCarcassReturns
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("submit_query", "Submit Query", "carcass_return_list")), 1)
                    ])
                ]),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: listFields.value,
                    "onUpdate:fields": _cache[5] || (_cache[5] = ($event) => ((listFields).value = $event)),
                    items: (0, vue_2.unref)(carcassStore).carcasses,
                    striped: "",
                    condensed: "",
                    panel: ""
                }, {
                    "cell-actions": (0, vue_2.withCtx)(({ item: carcass }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary btn-link",
                                onClick: ($event) => (openCarcassModel(carcass))
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("files", "Files", "carcass_return_list")), 9, _hoisted_7)
                        ])
                    ]),
                    _: 1
                }, 8, ["fields", "items"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    closeable: false,
                    isOpen: successfulSubmissionModalIsOpen.value,
                    title: selectedCarcass.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('successful_modal_header', '#{id} - Carcass return Data - {date}', 'carcass_return_list', { id: selectedCarcass.value.id, date: selectedCarcass.value.createdDate })
                        : '',
                    onClose: _cache[8] || (_cache[8] = ($event) => (successfulSubmissionModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (errorMessage.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                                key: 0,
                                message: errorMessage.value
                            }, null, 8, ["message"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_8, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.FileInput), {
                                modelValue: uploadedFile.value,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((uploadedFile).value = $event))
                            }, {
                                button: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-rounded btn-primary",
                                        onClick: saveCarcassFile
                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("upload", "Upload", "carcass_return_list")), 1)
                                ]),
                                _: 1
                            }, 8, ["modelValue"])
                        ]),
                        (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                            fields: listFileFields.value,
                            "onUpdate:fields": _cache[7] || (_cache[7] = ($event) => ((listFileFields).value = $event)),
                            items: (0, vue_2.unref)(carcassStore).carcassFiles,
                            striped: "",
                            condensed: "",
                            panel: ""
                        }, {
                            "cell-originalFileName": (0, vue_2.withCtx)(({ item: carcassFile }) => [
                                (0, vue_2.createElementVNode)("a", {
                                    href: carcassFile.url,
                                    download: "",
                                    class: "font-bold"
                                }, (0, vue_2.toDisplayString)(carcassFile.name), 9, _hoisted_9)
                            ]),
                            "cell-actions": (0, vue_2.withCtx)(({ item: carcassFile }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-rounded btn-danger btn-link",
                                        onClick: ($event) => (deleteCarcassFile(carcassFile.id))
                                    }, [
                                        _hoisted_12,
                                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "carcass_return_list")), 1)
                                    ], 8, _hoisted_11)
                                ])
                            ]),
                            _: 1
                        }, 8, ["fields", "items"])
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
